<template>
  <div>
    <Modal v-model="visible" :width="1000">
      <template #header>
        <p>配置资产计费策略</p>
      </template>

      <Row class="m-b-10">
        <i-col span="24">
          <div class="m-b-5" style="margin:16rpx 0px;">
            <strong class="m-r-10">选择资产</strong>
            <Checkbox
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll">全选
            </Checkbox>
          </div>
          <div>
            <CheckboxGroup v-model="checkCoIds" @on-change="checkAllCoIdChange">
              <Checkbox
                v-for="item in resourceArray"
                :key="item.id"
                :label="item.id"
                >{{ item.objectName }} ({{ item.resourceTypeName }} {{ item.number }}{{ formatObjectTypeName(item.objectType) }})</Checkbox
              >
            </CheckboxGroup>
          </div>
        </i-col>
      </Row>

      <Row class="m-b-10">
        <i-col span="24">
          <div  style="margin:10px 0px;">
            <strong>设置计费周期</strong>
          </div>
          <Row :gutter="8" class="mb-2">
            <DatePicker type="date" v-model="strategy.startDate" :clearable="false" size="small" placeholder="计费开始日期" style="width: 150px"></DatePicker>
            <span class="m-l-5 m-r-5">-</span>
            <DatePicker type="date" v-model="strategy.endDate" :clearable="false" size="small" placeholder="计费结束日期" style="width: 150px"></DatePicker>
          </Row>
        </i-col>
      </Row>

      <Row class="m-b-10">
        <i-col span="24">
          <div  style="margin:10px 0px;">
            <strong>设置计费策略</strong>
          </div>
          <Row :gutter="8" class="mb-2">
            <i-col span="3">
              <label class="mr-2 text-gray-400 leading-6">计费类型</label>
              <i-select v-model="strategy.feeType" class="w-full">
                <Option v-for="fee in feeArray" :key="fee.id" :value="fee.id">{{ fee.name }}</Option>
              </i-select>
            </i-col>
            <i-col span="2">
              <label class="mr-2 text-gray-400 leading-6">计费周期</label>
              <i-select v-model="strategy.dateUnit" class="w-full">
                <Option v-for="item in dateUnitArray" :value="item.value" :key="item.value"> {{ item.name }} </Option>
              </i-select>
            </i-col>
            <i-col span="4">
              <label class="mr-2 text-gray-400 leading-6">起始计费单价</label>
              <Input v-model="strategy.signPrice" type="number" number>
                <template #append>
                  <span>元/{{formatDateUnit(strategy.dateUnit)}}</span>
                </template>
              </Input>
            </i-col>
            <i-col span="3">
              <label class="mr-2 text-gray-400 leading-6">递增起始月</label>
              <Input v-model="strategy.upStartMonth" type="number" number>
                <template #prepend>
                  <span>自</span>
                </template>
                <template #append>
                  <span>⽉起</span>
                </template>
              </Input>
            </i-col>
            <i-col span="3">
              <label class="mr-2 text-gray-400 leading-6">递增周期</label>
              <Input v-model="strategy.month" type="number" number>
                <template #append>
                  <span>⽉</span>
                </template>
              </Input>
            </i-col>
            <i-col span="3">
              <label class="mr-2 text-gray-400 leading-6">递增类型</label>
              <i-select v-model="strategy.upType" class="w-full">
                <Option :value="1"> 百分比 </Option>
                <Option :value="2"> 固定金额 </Option>
              </i-select>
            </i-col>
            <i-col span="3">
              <label class="mr-2 text-gray-400 leading-6">递增幅度</label>
              <Input v-model="strategy.upValue" type="number" number>
                <template #append>
                  <span>{{ strategy.upType === 1 ? "%" : "元" }}</span>
                </template>
              </Input>
            </i-col>
            <i-col span="3">
              <div class="mr-2 text-gray-400 leading-6" style="width: 100%">
                &nbsp;
              </div>
              <i-button
                type="success"
                @click="confirmGenerate"
              >
                生成费用方案
              </i-button>
            </i-col>
          </Row>
        </i-col>
        <!-- <i-col span="24" class="m-t-5 m-b-5 remark">
          <Icon
            type="ios-alert-outline"
            style="font-size: 14px; color: #ef4444"
          />
          因多选资产导致计费混乱，商铺以每平米、机具以1台为起始单位
        </i-col> -->
      </Row>

      <Divider dashed style="margin-bottom: 5px;"/>
      <Tabs v-model="TabRsourceId">
        <TabPane v-for="item in resourceArray"
          :label="item.objectName + '( '+ item.resourceTypeName +' )'"
          :key="'data'+item.id"
          :name="'tab' + item.id"></TabPane>
      </Tabs>
      <Table :columns="rentSettingColumn" stripe size="small" :data="rentSettingData.filter(x=>x.coId===ChkResourceId)"></Table>

      <template #footer>
        <i-button
          type="primary"
          :disabled="allowSubmit"
          @click="confirmRentSet()"
        >
          确认修改
        </i-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import em from '@/utils/enum'
import { ParseDate } from '@/utils/dateFormat'
import { toMoney } from '@/utils/wnumb_own'
/** new api */
import { listObjectFee, createFeePlan, saveObjectFeeList, computeFeePlan } from '@/api/invest/contract'
import { listDictLabel } from '@/api/invest/dict'

export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,

      indeterminate: false,
      checkAll: false,
      checkCoIds: [],

      feeArray: [],
      dateUnitArray: em.dateUnitArray,

      strategy: {
        coIds: null,
        contractId: 0,
        dateUnit: 1,
        feeType: 1,
        month: 12,
        // number: 0,
        signPrice: 0,
        upStartMonth: 12,
        upType: 1,
        upValue: 0,
        startDate: null,
        endDate: null
      },
      totalSignArea: 0,
      rentSetInfo: [],

      resourceArray: [],
      ChkResourceId: 0,
      TabRsourceId: '',

      rentSettingColumn: [
        { title: '计费类型', width: '120', key: 'feeTypeName' },
        { title: '开始日期', key: 'startDate' },
        { title: '结束日期', key: 'endDate' },
        {
          title: '计费数量',
          key: 'number',
          align: 'center',
          render: (h, params) => {
            // let unit = ' ㎡'
            // if (params.row.objectType === 3007) {
            //   unit = ' 台'
            // }

            // return h('span', params.row.number + unit)
            return h('span', params.row.number)
          }
        },
        {
          title: '计费单价',
          width: '150',
          align: 'right',
          render: (h, params) => {
            const showlabel = params.row.signPrice
            const editButton = h('Icon', {
              domProps: {
                title: '编辑计费单价'
              },
              props: { type: 'md-create', size: 16, color: '#2d8cf0' },
              style: { 'margin-left': '8px', cursor: 'pointer' },
              on: {
                click: () => {
                  this.handleEditItem(params.row)
                }
              }
            })

            return h('div', [showlabel, editButton])
          }
        },
        {
          title: '小计',
          width: '120',
          align: 'right',
          render: (h, params) => {
            return h('span', params.row.monthPrice + ' / ' + (this.formatDateUnit(params.row.dateUnit)))
          }
        },
        {
          title: '合计',
          width: '120',
          align: 'right',
          render: (h, data) => {
            return h('span', {
              attrs: {
                class: 'money'
              }
            }, data.row.totalPrice)
          }
        },
        {
          title: '操作',
          width: '150',
          align: 'right',
          render: (h, params) => {
            const deleteButton = h(
              'a',
              {
                style: {
                  marginRight: '5px',
                  color: '#ef4f4f'
                },
                on: {
                  click: () => {
                    this.handleDeleteItem(params.row)
                  }
                }
              },
              '删除'
            )

            return h('div', [deleteButton])
          }
        }
      ],
      historyRentSettingData: [], // 已提交的方案数据
      showRentSettingData: [], // 需要按分组来显示的方案数据
      deleteRentSettingData: [], // 需要删除的数据集合
      rentSettingData: []
    }
  },
  mounted () {},
  created () {
    this.initBaseData()
  },
  methods: {
    initBaseData () {
      listDictLabel({ dictType: 'fee_type' }).then(res => {
        this.feeArray = res.map(x => {
          return {
            id: parseInt(x.id),
            name: x.name
          }
        })
      })
    },
    formatMoney (number) {
      return toMoney(number)
    },
    formatDateUnit (type) {
      const unit = this.dateUnitArray.find(x => x.value === type)
      return unit ? unit.name : ''
    },
    formatObjectTypeName (objectType) {
      let unit = ''
      if (objectType === 3007) {
        unit = ' 台'
      } else if ([3006, 3013].includes(objectType)) {
        unit = ' ㎡'
      }

      return unit
    },
    showModal (contractResouces, defaultResourceId) {
      this.resourceArray = []

      this.resourceArray = this.resourceArray.concat(contractResouces)
      this.ChkResourceId = defaultResourceId
      this.TabRsourceId = 'tab' + defaultResourceId
      this.checkCoIds = [defaultResourceId]
      this.deleteRentSettingData = []
      this.strategy.startDate = this.contractInfo.startDate
      this.strategy.endDate = this.contractInfo.endDate
      this.visible = true

      // 获取已生成的租金方案
      listObjectFee({ contractId: this.contractInfo.id }).then(res => {
        this.historyRentSettingData = res
        this.rentSettingData = res
      })
    },

    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false

      if (this.checkAll) {
        this.checkCoIds = this.resourceArray.map(x => x.id)
      } else {
        this.checkCoIds = []
      }
    },
    checkAllCoIdChange (data) {
      if (data.length === this.resourceArray.length) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
    },

    // 确认生成租金方案
    confirmGenerate () {
      // 判断当前方案清单中是否存在相同类型的数据， 如果有那么弹出确认窗口，否则直接生成
      if (this.rentSettingData.some(x => this.checkCoIds.includes(x.coId) && x.feeType === this.strategy.feeType)) {
        this.$Modal.confirm({
          title: '操作确认',
          content:
          '当前资产已存在相同类型租金策略，您确定要重新生成租金方案吗？ 这样将导致已存在的方案被【 移除 】',
          onOk: () => {
            // 执行删除操作
            this.deleteRentSettingData = this.deleteRentSettingData.concat(this.rentSettingData.filter(x => this.checkCoIds.includes(x.coId) && x.feeType === this.strategy.feeType))
            this.rentSettingData = this.rentSettingData.filter(x => !(this.checkCoIds.includes(x.coId) && x.feeType === this.strategy.feeType))
            this.beginGenerateRentSetting()
          }
        })
      } else {
        this.beginGenerateRentSetting()
      }
    },
    beginGenerateRentSetting () {
      this.strategy.contractId = this.contractInfo.id
      this.strategy.coIds = this.checkCoIds.join(',')
      this.strategy.startDate = ParseDate(this.strategy.startDate)
      this.strategy.endDate = ParseDate(this.strategy.endDate)

      createFeePlan(this.strategy).then(res => {
        if (res) {
          // 合并到现有
          this.rentSettingData = this.rentSettingData.concat(res)
        }
      })
    },
    confirmRentSet () {
      this.$Modal.confirm({
        title: '操作确认',
        content:
          '确认保存当前租金策略？',
        onOk: () => {
          const query = {
            contractId: this.contractInfo.id,
            coFeeList: this.getUpdateRentSetData()
          }

          saveObjectFeeList(query).then((res) => {
            this.$store.commit('set_contract_update', new Date())
            this.visible = false
          })
        }
      })
    },
    getUpdateRentSetData () {
      const updateData = []
      this.resourceArray.forEach(element => {
        // 删除清单中，仅提交id不为空的值
        updateData.push({
          coId: element.id,
          delIdList: this.deleteRentSettingData.filter(x => x.id !== -1 && x.coId === element.id).map(x => x.id),
          feeList: this.rentSettingData.filter(x => (x.id === -1 || x.isUpdate) && x.coId === element.id)
        })
      })

      return updateData
    },
    handleEditItem (param) {
      let updateSignPrice = param.signPrice

      this.$Modal.confirm({
        title: '自定义计费单价',
        render: (h) => {
          const showlabels = [
            h('p', `计费类型：${param.feeTypeName}`),
            h('p', `开始日期：${param.startDate}`),
            h('p', `结束日期：${param.endDate}`)
          ]

          const inputVal = h('p', ['计费单价：', h('Input', {
            style: { width: '120px' },
            props: {
              type: 'number',
              value: param.signPrice,
              autofocus: true,
              placeholder: '请填写新的计费单价'
            },
            on: {
              input: (val) => {
                updateSignPrice = val
              }
            }
          })])
          showlabels.push(inputVal)
          return h('div', showlabels)
        },
        loading: true,
        onOk: () => {
          const updateBean = {
            dateUnit: param.dateUnit,
            endDate: param.endDate,
            number: param.number,
            signPrice: updateSignPrice,
            startDate: param.startDate
          }

          computeFeePlan(updateBean).then((res) => {
            if (res && !res.errcode) {
              const updateItem = this.rentSettingData.filter(x => x.coId === this.ChkResourceId)[param._index]

              updateItem.monthPrice = res.monthPrice
              updateItem.totalPrice = res.totalPrice
              updateItem.signPrice = updateSignPrice
              if (updateItem.id > 0) { // 执行删除和添加操作
                updateItem.isUpdate = true
              }
            }
            this.$Modal.remove()
          })
            .catch((error) => {
              this.$Modal.remove()
              this.$Notice.error({
                title: '服务器请求错误',
                desc: error
              })
            })
        }
      })
    },
    handleDeleteItem (param) {
      if (param.id !== -1) {
        this.deleteRentSettingData.push(param)
      }

      this.rentSettingData.splice(param._index, 1)
    }
  },
  watch: {
    ChkResourceId (newVal, oldVal) {
      this.TabRsourceId = 'tab' + newVal
    },
    TabRsourceId (newVal, oldVal) {
      this.ChkResourceId = parseInt(newVal.substr(3))
    }
  },
  computed: {
    contractInfo () {
      return this.$store.state.investmentContract.contractInfo
    },
    allowSubmit () {
      const allow = true
      // this.rentSetInfo.forEach((item, index) => {
      //   if (!item.startDate || !item.endDate) {
      //     // 新增日期项为空
      //     allow = false
      //   } else if (new Date(item.startDate).getTime() > new Date(item.endDate).getTime()) {
      //     // 开始日期大于结束日期
      //     allow = false
      //   } else if (new Date(item.endDate).getTime() > new Date(this.contractInfo.endDate).getTime()) {
      //     // 超过合同结束日期范围
      //     allow = false
      //   }
      // })

      return !allow
    }
  }
}
</script>
